<!-- eslint-disable -->
<template lang="pug">
    .carousel-container
        .scene-container(:class="{'scene-container--large': showingCouples.length <= 4}")
            .scene(@wheel="handleRotate($event)")
                .carousel
                    .carousel__cell(v-for='(couple, index) in showingCouples')
                        .left-block
                            img.image(v-if="couple.left.type === 'image'", :src='couple.left.value | apiFile')
                            div.carousel__text-container(v-else)
                                | {{ couple.left.value }}
                        .answer-block(v-if="!isItUsualExample(couple)")
                            div.carousel__text-container
                                | {{ getSign(couple) }}
                        .right-block
                            img.image(v-if="!gameStarted && couple.right.type === 'image'" :src='couple.right.value | apiFile')
                            drop(
                                v-if="couple.right.type === 'dropZone' && showingCoupleIndex === index"
                                class="drop-zone"
                                @drop="dropItemInRightReel(couple, $event)"
                            )
                                div.drop-zone__shake-zone
                            drag(
                                v-if="!isMobile && couple.right.type === 'image'",
                                :draggable="index === showingCoupleIndex",
                                :transfer-data="{ item: couple.right, index: activeCoupleIndex, from: 'right-column' }",
                                @dragstart="$emit('blockReelsScroll')",
                                @dragend="$emit('unlockReelsScroll')",
                                @touchmove="$emit('blockReelsScroll')"
                            )
                                img.image(:src='couple.right.value | apiFile')
                            div.right-block__tapped-image(
                                v-if="gameStarted && couple.right.type === 'image' && isMobile",
                                :class="activeCoupleIndex === index && 'right-block__tapped-image_pointer'"
                                :data-active-index="activeCoupleIndex",
                                :data-from="'right-column'",
                                :data-index="index"
                            )
                                img.image(:src='couple.right.value | apiFile')
                        .answer-block(v-if="isItUsualExample(couple)")
                            div.carousel__text-container
                                | ={{ couple.correctAnswer }}
</template>

<script>
    /*eslint-disable*/
    import _ from 'lodash';
    import { Drag, Drop } from 'vue-drag-drop';
    const RADIUS = 3;
    const DEFAULT_VOLUME = 0.6;
    const MAX_AMOUNT_OF_COUPLES = 13;
    const BOUNDARY = 6;

    export default {
        props: {
            couples: {
                type: Array,
                default: () => []
            },
            showFieldsForAnswers: Boolean,
            gameStarted: Boolean,
            mode: String,
            dragStarted: Boolean,
            disableReplyButton: Boolean,
            typeOfRightColumn: String,
            blockReelsScroll: {
                type: Boolean,
                default: false
            },
            isMobile: Boolean,
            rotateButtonClicked: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                carousel: null,
                cellWidth: 0,
                cellHeight: 0,
                indexForRotate: 0,
                radius: 0,
                theta: 0,
                cells: null,
                startGame: false,
                activeCoupleIndex: 0,
                directionOfCounting: true,
                soundInstance: null,
                showingCoupleIndex: 0
            }
        },
        watch: {
            showFieldsForAnswers () {
                if (this.mode === 'inTurn' && !this.gameStarted) {
                    if (this.indexForRotate < this.couples.length - 1) {
                        (this.indexForRotate === this.couples.length - 2) && this.$emit('showPlayButton');
                        this.showNewPair();
                    } else {
                        for (let i = 0; i < this.cells.length; i++) {
                            this.cells[i].style.opacity = 1 ;
                        }
                    }
                }
            },
            indexForRotate (value) {
                if (this.inputInActiveCell) {
                    this.inputInActiveCell.blur();
                }
                this.directionOfCounting = value >= 0;
                this.activeCoupleIndex = !this.directionOfCounting && (Math.abs(value) % this.couples.length)
                        ? this.couples.length - Math.abs(value) % this.couples.length
                        : Math.abs(value) % this.couples.length;
                this.showingCoupleIndex = !this.directionOfCounting && (Math.abs(value) % this.amountOfPairs)
                        ? this.amountOfPairs - Math.abs(value) % this.amountOfPairs
                        : Math.abs(value) % this.amountOfPairs;
                if (this.inputInActiveCell) {
                    this.$nextTick(() => {
                        this.inputInActiveCell.focus();
                    });
                }
            },
            dragStarted (value) {
                let shakeZone = document.querySelector('.drop-zone__shake-zone');
                this.cells[this.showingCoupleIndex].style.border = value && shakeZone ? "4px rgb(142, 193, 98) solid" : "";
                if (value && shakeZone) {
                    shakeZone.classList.add('shake');
                    setTimeout(() => {
                        shakeZone.classList.remove('shake');
                    }, 1000)
                }
            },
            rotateButtonClicked (newValue, oldValue) {
                if (newValue && !oldValue) {
                    this.indexForRotate++;
                    this.playScroll();
                    this.rotateCarousel();
                }
            }
        },
        mounted () {
            this.carousel = document.querySelector('.carousel');
            document.addEventListener('keydown', _.throttle(event => {
                if (this.mode === 'inTurn' && !this.gameStarted) {
                    return;
                }
                if (event.keyCode === 40) {
                    this.indexForRotate++;
                    this.playScroll();
                    this.rotateCarousel();
                } else if (event.keyCode === 38) {
                    this.indexForRotate--;
                    this.playScroll();
                    this.rotateCarousel();
                }
            }, 300));
            if (this.typeOfRightColumn !== 'image' && this.gameStarted) {
                this.addEventListenerOnInputs();
            }
            this.amountOfPairs = this.showingCouples.length;
            this.cells = document.querySelectorAll('.carousel__cell');
            this.cellWidth = this.carousel.offsetWidth;
            this.cellHeight = this.carousel.offsetHeight;
            this.startCarousel();
            this.addScroll();
        },
        beforeDestroy () {
            document.removeEventListener('keydown', this.rotateCarousel);
        },
        computed: {
            coupleDataInActiveCell () {
                if (this.typeOfRightColumn === 'image') {
                    return this.showingCouples[this.showingCoupleIndex].right;
                }
                return null;
            },
            inputInActiveCell () {
                if (this.typeOfRightColumn !== 'image') {
                    return this.cells[this.showingCoupleIndex].children[1].children[0].children[0];
                }
                return null;
            },
            showingCouples () {
                if (this.couples.length > MAX_AMOUNT_OF_COUPLES) {
                    let couples = [];
                    if (this.activeCoupleIndex - BOUNDARY < 0) {
                        let diff = this.activeCoupleIndex - BOUNDARY;
                        couples = this.couples.slice(this.activeCoupleIndex, this.activeCoupleIndex + BOUNDARY + 1);
                        couples = couples.concat(this.couples.slice(diff));
                        couples = couples.concat(this.couples.slice(0, this.activeCoupleIndex));
                    } else if (this.activeCoupleIndex + BOUNDARY + 1 >= this.couples.length) {
                        let diff = this.activeCoupleIndex + BOUNDARY + 1 - this.couples.length;
                        couples = this.couples.slice(this.activeCoupleIndex);
                        couples = couples.concat(this.couples.slice(0, diff));
                        couples = couples.concat(this.couples.slice(this.activeCoupleIndex - BOUNDARY, this.activeCoupleIndex));
                    } else {
                        couples = this.couples.slice(this.activeCoupleIndex, this.activeCoupleIndex + BOUNDARY + 1);
                        couples = couples.concat(this.couples.slice(this.activeCoupleIndex - BOUNDARY, this.activeCoupleIndex));
                    }
                    return this.showingCoupleIndex ? couples.splice(-this.showingCoupleIndex).concat(couples) : couples;
                }
                return this.couples;
            }
        },
        methods: {
            rotateCarousel () {
                let angle = this.theta * this.indexForRotate * -1;
                this.carousel.style.transform = 'translateZ(' + -this.radius + 'px) rotateX(' + angle + 'deg)';
                this.$emit('endCarouselRotate');
            },
            handleRotate (event) {
                if (this.mode === 'inTurn' && !this.gameStarted) {
                    return;
                }
                if (!this.blockReelsScroll) {
                    event.deltaY < 0 ? this.indexForRotate-- : this.indexForRotate++;
                    this.playScroll();
                    this.rotateCarousel();
                }
                this.$emit('unlockReelsScroll');
            },
            playScroll () {
                this.soundInstance = this.$createjs.Sound.play("couplesScroll");
                this.soundInstance.volume = DEFAULT_VOLUME;
            },
            startCarousel () {
                this.theta = 360 / this.showingCouples.length;
                this.radius = this.showingCouples.length > 2
                        ? Math.round( ( this.cellHeight / 2) / Math.tan( Math.PI / this.showingCouples.length ) )
                        : RADIUS;
                for (let i = 0; i < this.cells.length; i++) {
                    if (!this.gameStarted && this.mode === 'inTurn' && i > 0) {
                        this.cells[i].style.opacity = 0;
                    }
                    this.cells[i].style.transform = 'rotateX(' + this.theta * i + 'deg) translateZ(' + this.radius + 'px)';
                }
                this.soundInstance = this.$createjs.Sound.play("couplesReels");
                this.soundInstance.volume = DEFAULT_VOLUME;
                if (this.inputInActiveCell) {
                    this.inputInActiveCell.focus();
                }
                this.rotateCarousel();
            },
            showNewPair () {
                this.cells[this.showingCoupleIndex].style.opacity = 0;
                this.indexForRotate++;
                this.$nextTick(() => {
                    this.cells[this.showingCoupleIndex].style.opacity = 1;
                    this.playScroll();
                    this.rotateCarousel();
                });
            },
            addScroll () {
                let mc = new Hammer.Manager(this.carousel);
                mc.add(new Hammer.Swipe({
                    event: 'swipe',
                    pointers: 1,
                    threshold: 0,
                    direction: Hammer.DIRECTION_VERTICAL,
                    velocity: 0.3
                }));
                mc.on('swipe', _.throttle(event => this.handleRotate(event), 500));
            },
            addDoubleTapListener () {
                let cells = document.getElementsByClassName('right-block__tapped-image');
                if (cells.length) {
                    for (let i = 0; i < cells.length; i++) {
                        let mc = new Hammer.Manager(cells[i]);
                        mc.add( new Hammer.Tap({ event: 'doubletap', taps: 2 }) );
                        mc.on('doubletap', _.throttle(event => this.handleDoubleTappedImage(event), 500));
                    }
                }
            },
            dropItemInRightReel (couple, data) {
                if (data && data.from !== 'right-column') {
                    this.soundInstance = this.$createjs.Sound.play("couplesDrop");
                    this.soundInstance.volume = DEFAULT_VOLUME;
                    couple.right = _.cloneDeep(data.item);
                    this.$emit('dropItemInRightReel', data.index);
                    this.rotateCarouserAfterAnswer();
                    this.$nextTick(() => {
                        if (this.typeOfRightColumn === 'image') {
                            this.addDoubleTapListener();
                        }
                    });
                }
            },
            addEventListenerOnInputs () {
                let inputs = document.getElementsByClassName('carousel__text-input');
                for (let i = 0; i < inputs.length; i++) {
                    inputs[i].addEventListener('keydown', event => {
                        if (event.keyCode === 13 && _.trim(inputs[i].value)) {
                            this.rotateCarouserAfterAnswer();
                        }
                    })
                }
            },
            rotateCarouserAfterAnswer () {
                this.$nextTick(() => {
                    if (this.disableReplyButton) {
                        this.indexForRotate--;
                        this.playScroll();
                        this.rotateCarousel();
                    } else {
                        this.$emit('addFocusOnReplyButton');
                    }
                })
            },
            returnImageToAnswersBox (transferData) {
                this.$emit('dropItemInAnswersBox', transferData);
            },
            handleDoubleTappedImage (event) {
                let dataSet = event.target.dataset;
                let item = _.cloneDeep(this.coupleDataInActiveCell);
                if (dataSet.index === dataSet.activeIndex && item.type === 'image') {
                    let transferData = {
                        index: dataSet.activeIndex,
                        from: dataSet.from,
                        item: item,
                    };
                    this.returnImageToAnswersBox(transferData);
                }
            },
            isItUsualExample (couple) {
                return couple.correctAnswer !== 'equality' && !couple.correctAnswer.match('inequality')
            },
            getSign (couple) {
                if (couple.correctAnswer === 'equality') {
                    return '=';
                } else if (couple.correctAnswer.match('inequality') && couple.correctAnswer.match('>')) {
                    return '>';
                } else if (couple.correctAnswer.match('inequality') && couple.correctAnswer.match('<')) {
                    return '<';
                }
            }
        },
        components: {
            Drag,
            Drop
        }
    }
</script>

<style lang="scss" scoped>
    .carousel-container {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .scene {
        width: 100%;
        height: 100%;
        text-align: center;
        perspective: 500px;
        margin: 0 auto;
    }
    .carousel {
        width: 100%;
        height: 100%;
        white-space: nowrap;
        position: absolute;
        transform: translateZ(-288px);
        transform-style: preserve-3d;
        transition: transform 0.3s;
    }
    .carousel__text-container {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
        font-size: 3rem;
        overflow-wrap: break-word;
        white-space: normal;
        background: white;
        @include media($sm) {
            font-size: 5rem;
        }
    }

    .carousel__text-input {
        border-radius: 0;
        text-align: center;
        font-size: 20px;
        border-top: none;
        border-left: none;
        border-right: none;
        background: transparent;

        &::placeholder {
            font-size: 20px;
        }
    }


    .left-block, .right-block, .answer-block {
        background: $x-color-white;
        border: 2px solid #F5F5F5;
        width: calc(100% / 3);
        height: 100%;
        display: inline-block;
    }

    .right-block, .answer-block:not(:last-child) {
        background: #F7F7FF;
        border: 2px solid #E6E6F8;
        box-sizing: border-box;
    }

    .right-block__tapped-image_pointer, .answer-block__tapped-image_pointer:not(:last-child) {
        cursor: pointer;
    }

    .carousel__cell {
        position: absolute;
        width: 100%;
        height: 100%;
        font-weight: 500;
        font-size: 40px;
        line-height: 47px;
        color: $x-color-black;
        text-align: center;
        transition: transform 1s, opacity 1s;
        user-select: none;
        display: flex;
        @include media($sm) {
            font-size: 51px;
            line-height: 60px;
        }
        @include media($md) {
            font-size: 66px;
            line-height: 79px;
        }
        @include media($lg) {
            font-size: 80px;
            line-height: 95px;
        }
    }

    .carousel__cell > .image {
        width: 100%;
        max-height: 135px;
        @include media($sm) {
            width: auto;
            max-height: none;
        }
    }

    .image, .text {
        pointer-events: none;
        user-select: none;
    }
    .scene-container {
        display: inline-block;
        width: 300px;
        height: 100px;
        @include media($sm) {
            width: 381px;
            height: 127px;
        }
        @include media($md) {
            width: 495px;
            height: 165px;
        }
        @include media($lg) {
            width: 600px;
            height: 200px;
        }
    }

    .scene-container--large {
        width: 330px;
        height: 110px;
        @include media($sm) {
            width: 420px;
            height: 140px;
        }
        @include media($md) {
            width: 480px;
            height: 160px;
        }
        @include media($lg) {
            width: 600px;
            height: 200px;
        }
        @include media($xxl) {
            width: 960px;
            height: 320px;
        }
    }
    .drop-zone {
        width: 100%;
        height: 100%;
        display: flex;
    }

    .drop-zone__shake-zone {
        width: 100%;
        height: 100%;
        margin: auto;
    }

    @import '@/assets/sass/animations/shake.scss';
</style>
